import {makeType,actionCreator} from '../../Utils/generateActionCreator';

const actionType = makeType('DATA');

export const ADD_CONTRATANT = actionType('ADD_CONTRATANT')
export const ADD_ASSURED = actionType('ADD_ASSURED')
export const ADD_ID_PROSPECTO = actionType('ADD_ID_PROSPECTO')
export const UPDATE_ASSURED = actionType('UPDATE_ASSURED')
export const UPDATE_CONTRATANT = actionType('UPDATE_CONTRATANT')
export const REMOVE_ASSURED = actionType('REMOVE_ASSURED')
export const REMOVE_ALL = actionType('REMOVE_ALL')
export const ADD_REP_LEGAL = actionType('ADD_REP_LEGAL')

export const addAssured = actionCreator(ADD_ASSURED, 'assured')
export const updateAssured = actionCreator(UPDATE_ASSURED, 'assured')
export const addIdProspecto = actionCreator(ADD_ID_PROSPECTO, 'idProspecto')
export const addContratant = actionCreator(ADD_CONTRATANT, 'contratant')
export const updateContratant = actionCreator(UPDATE_CONTRATANT, 'contratant')
export const removeAssured = actionCreator(REMOVE_ASSURED, 'assured')
export const removeAll = actionCreator(REMOVE_ALL, 'contratant')
export const addRepLegal = actionCreator(ADD_REP_LEGAL, 'repLegal')
